// extracted by mini-css-extract-plugin
export default {"ContactUsSection":"style_ContactUsSection__DqMIV","heroSection":"style_heroSection__Yl9rr","contactTextSection":"style_contactTextSection__SvCtt","RedLine":"style_RedLine__1kKD6"};